import React from 'react';
import ResponsiveImage from 'components/elements/common/ResponsiveImage/ResponsiveImage';
import Truncate from 'react-truncate';
import { Link } from 'react-router-dom';
import { getStoryTitle, isInternalLink, host } from 'utils/helpers';
import { LEDE_MODULE_TITLE } from 'components/utils/constants';
import './Story.scss';

export const formatLink = ({ id, url }) => {
  if (id) {
    return `/news/${id}`;
  }
  return url.split(host()).pop();
};

const InternalExternalLink = (props) => {
  if (isInternalLink(props.story)) {
    const link = formatLink(props.story);
    return (
      <Link className={props.className} to={link}>{props.children}</Link>
    );
  }
  return (
    <a href={props.story.url} className={props.className} target="_blank" rel="noopener noreferrer">{props.children}</a>
  );
};

const Story = ({ story, crops, className = '', showLabel, row, column, moduleTitle }) => {
  const { thumbnail, label } = story;
  const title = getStoryTitle(story);
  const includeLabel = showLabel !== undefined ? showLabel && label : false;
  const isLede = moduleTitle === LEDE_MODULE_TITLE;
  const TitleElement = isLede ? 'span' : Truncate;

  if (!thumbnail) {
    console.warn(`Missing thumbnail object for ${story.id}`);
    return null;
  }

  return (
    <InternalExternalLink className={`topic-story ${className}`.trim()} {...{ story, row, column, moduleTitle, title }}>
      <ResponsiveImage imageUrl={story.thumbnail.url} crops={crops} title={`Story - ${title}`} />
      <div className="topic-story-title">
        <TitleElement className={`topic-story-title__title ${isLede ? 'topic-lede-title' : ''}`} lines={2} ellipsis={'...'}>
          <div dangerouslySetInnerHTML={{ __html: title }} />
        </TitleElement>
        {includeLabel && <span className="topic-story-label" dangerouslySetInnerHTML={{ __html: label }} />}
      </div>
    </InternalExternalLink>
  );
};

export default Story;
